module.exports = __webpack_public_path__ + "static/media/2025-AFL-Origin-Guernsey-Giveaway-Logged-Out.062f5d80.jpg";